import * as fs from "fs";

import { xml2json } from "xml-js";

import { CsJsonObject } from "../models.helper/CsJsonObject";

export function convertJsonStringToCsJsonObject(jsonString: string): CsJsonObject {
  return new CsJsonObject(JSON.parse(jsonString));
}

export function convertXmlStringToCsJsonObject(xmlString: string): CsJsonObject {
  return new CsJsonObject(JSON.parse(xml2json(xmlString, { compact: true })));
}

export function formatJsonString(object: any): string {
  return JSON.stringify(object);
}

export async function getCsJsonObjectFromXmlFileAsync(
  xmlFileName: string
): Promise<CsJsonObject> {
  return new Promise(async function (resolve, reject) {
    fs.readFile(xmlFileName, "utf8", function (err, xmlData) {
      if (err) {
        return reject(err);
      }
      return resolve(convertXmlStringToCsJsonObject(xmlData));
    });
  });
}

export function isJsonString(stringToCheck: string) {
  try {
    JSON.parse(stringToCheck);
  } catch (e) {
    return false;
  }
  return true;
}
